import { useEffect, useState, lazy, Suspense } from "react";
import { Spin } from "antd";

const UserManagementDesktop = lazy(() => import("./user-management-desktop"));
const UserManagementMobile = lazy(() => import("./user-management-mobie"));

const UserManagement = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 900);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  return (
    <Suspense fallback={<Spin fullscreen size="large" tip="Đang tải giao diện..." />}>
      {isMobile ? <UserManagementMobile /> : <UserManagementDesktop />}
    </Suspense>
  );
};

export default UserManagement;